import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/teacher/resourceSection"

const resourceSection = {
  resourceSectionListPage(pageSize, limit, keyWord, subjectId, versionId, bookId) {
    return axios.get(pre + `/resourceSectionListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          subjectId: subjectId,
          versionId: versionId,
          bookId: bookId,
        }
    });
  },
  resourceSectionSortAllList(subjectId, classId, versionId, bookId) {
    return axios.get(pre + `/resourceSectionSortAllList`, {
      params:
        {
          subjectId: subjectId,
          classId: classId,
          versionId: versionId,
          bookId: bookId,
        }
    });
  },
  resourceSectionChildSortList(sectionId) {
    return axios.get(pre + `/resourceSectionChildSortList`, {
      params:
        {
          sectionId: sectionId
        }
    });
  },
  resourceSectionInfo(id) {
    return axios.get(pre + `/resourceSectionInfo`, {params: {id: id}});
  },
  saveResourceSection(params) {
    return axios.post(pre + `/saveResourceSection`, qs.stringify(params));
  },
  resourceSectionDelete(id) {
    return axios.delete(pre + `/resourceSectionDelete`, {params: {id: id}});
  },
}
export default resourceSection;



// WEBPACK FOOTER //
// ./src/api/teacher/resourceSection.js